export default __webpack_public_path__ + "static/media/BlindOn.5faa43d2.svg";